<template>
  <div
    class="refapp-video-youtube"
    :class="{ 'refapp-video--high-contrast-text': highContrastTextEnabled }"
  >
    <youtube-embed
      v-if="autoplay || isYoutubePlaying"
      :video-id="youtubeId"
      :muted="muted"
      :autoplay="autoplay"
      :title="heading"
    />
    <div v-else class="refapp-video-youtube__thumbnail">
      <span class="ra-sr-only">{{ a11yLabels.video }}</span>
      <img :src="poster" alt="" class="refapp-video-youtube__thumbnail-image" />
      <refapp-video-content>
        <slot></slot>
      </refapp-video-content>
      <div class="refapp-video__controls">
        <button
          type="button"
          class="refapp-video__controls-button refapp-video__controls-playback refapp-video__controls-playback--paused"
          :aria-label="a11yLabels.accessVideo"
          @click="playYoutube"
        ></button>
      </div>
    </div>
  </div>
</template>

<script>
import RefappVideoContent from './content.vue';
import YoutubeEmbed from './youtube-embed.vue';

export default {
  name: 'refapp-video-youtube',
  components: {
    RefappVideoContent,
    YoutubeEmbed,
  },
  inject: [
    'youtubeId',
    'autoplay',
    'muted',
    'poster',
    'highContrastTextEnabled',
    'a11yLabels',
    'heading',
  ],
  data() {
    return {
      isYoutubePlaying: false,
    };
  },
  methods: {
    playYoutube() {
      this.isYoutubePlaying = true;
    },
  },
};
</script>
